/**
 * Created by m.igrachev on 4/8/2016.
 */
import React from "react";
import PropTypes from "prop-types";
import Tooltip from "../tooltip/Tooltip";
import documentedProps from "./documentation/ActionDocumentedProperties";

export default class Action extends React.Component {
    onClick(id, event) {
        if (event) {
            event.stopPropagation();
        }

        if (this.props.onClick) {
            this.props.onClick(id);
        }
    }

    buildActionJSX(icon, label, tooltip, rightIcon) {
        let result = null;
        let iconClass = icon;
        iconClass += this.props.marker ? " tq-marker" : "";
        if (tooltip) {
            let tooltipContainerClasses = this.props.tooltipContainerClasses;
            let maxWidth = this.props.tooltipMaxWidth ? this.props.tooltipMaxWidth + "px" : "";
            if (icon) {
                if (label) {
                    if (rightIcon) {
                        result = (
                            <div className="tq-item">
                                <Tooltip
                                    placeholderClass={tooltipContainerClasses}
                                    value={tooltip}
                                    maxWidth={maxWidth}
                                >
                                    <span className="tq-text-node">{label}</span>
                                    <i className={iconClass} />
                                </Tooltip>
                            </div>
                        );
                    } else {
                        result = (
                            <div className="tq-item">
                                <Tooltip value={tooltip} maxWidth={maxWidth}>
                                    <i className={iconClass} />
                                    <span className="tq-text-node">{label}</span>
                                </Tooltip>
                            </div>
                        );
                    }
                } else {
                    result = (
                        <div className="tq-item">
                            <Tooltip value={tooltip} maxWidth={maxWidth}>
                                <i className={iconClass} />
                            </Tooltip>
                        </div>
                    );
                }
            } else {
                if (label) {
                    result = (
                        <div className="tq-item">
                            <Tooltip value={tooltip} maxWidth={maxWidth}>
                                <span className="tq-text-node">{label}</span>
                            </Tooltip>
                        </div>
                    );
                }
            }
        } else {
            if (icon) {
                if (label) {
                    if (rightIcon) {
                        result = (
                            <div className="tq-item">
                                <span className="tq-text-node">{label}</span>
                                <i className={iconClass} />
                            </div>
                        );
                    } else {
                        result = (
                            <div className="tq-item">
                                <i className={iconClass} />
                                <span className="tq-text-node">{label}</span>
                            </div>
                        );
                    }
                } else {
                    result = (
                        <div className="tq-item">
                            <i className={iconClass} />
                        </div>
                    );
                }
            } else {
                if (label) {
                    result = (
                        <div className="tq-item">
                            <span className="tq-text-node">{label}</span>
                        </div>
                    );
                }
            }
        }

        return result;
    }

    render() {
        var actionJSX = this.buildActionJSX(
            this.props.icon,
            this.props.label,
            this.props.tooltip,
            this.props.rightIcon
        );
        var activeClass = this.props.active ? "tq-current" : "";
        return (
            <li
                className={activeClass}
                key={this.props.id}
                onClick={this.onClick.bind(this, this.props.id)}
                data-tq-id={this.props.dataTqId}
            >
                {actionJSX}
            </li>
        );
    }
}

Action.displayName = "Action";

Action.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    icon: PropTypes.string,
    marker: PropTypes.bool,
    tooltip: PropTypes.string,
    tooltipMaxWidth: PropTypes.number,
    tooltipContainerClasses: PropTypes.string,
    onClick: PropTypes.func,
    rightIcon: PropTypes.bool,
    active: PropTypes.bool,
    dataTqId: PropTypes.string
};

Action.documentedProps = documentedProps;
